import { useEffect, useState } from 'react';
import { laboratoryClient } from '../clients/laboratoryClient';
export const useIsConv0001Variant = () => {
  const [isConv0001Variant, setIsConv0001Variant] = useState(false);
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      const group = treatments['conv-0001']['parameters']['group'];
      setIsConv0001Variant(group !== 'control');
    });
  }, [isConv0001Variant]);
  return isConv0001Variant;
};